/**
 * 予約販売：商品ページの hidden input 同期
 * ------------------------------------------------------------
 * バリアント切り替え時に、ライン明細プロパティ用 hidden input の
 * 値と disabled 属性を予約状態に追従させる。
 *
 * global.js には手を入れない。
 * 既存実装が #PreorderNotice-{sectionId} の innerHTML を差し替えているため、
 * その変化を MutationObserver で拾って判定する。
 *
 * 入荷予定はバリアント単位のメタフィールドになったため、
 * バリアントが変われば文言も変わる。
 * disabled だけでなく value も同期する必要がある点が、
 * 商品単位だった頃との違い。
 *
 * 値の取得元は snippets/preorder-notice.liquid が出力する
 * [data-preorder-state="true"][data-preorder-text] のみ。
 * これにより、顧客が商品ページで見た文言と
 * 記録される文言が必ず一致する。
 *
 * 存在しない組み合わせを選択して setUnavailable() が innerHTML を
 * 空にした場合も、同じ経路で disabled になる。
 */

(function () {
  if (window.__preorderProductInitialized) return;
  window.__preorderProductInitialized = true;

  const NOTICE_PREFIX = 'PreorderNotice-';
  const NOTICE_SELECTOR = '[id^="' + NOTICE_PREFIX + '"]';
  const STATE_SELECTOR = '[data-preorder-state="true"]';

  function syncInput(notice) {
    if (!notice || !notice.id) return;

    const sectionId = notice.id.slice(NOTICE_PREFIX.length);
    const input = document.getElementById('PreorderProperty-' + sectionId);
    if (!input) return;

    const state = notice.querySelector(STATE_SELECTOR);

    if (state) {
      const text = state.dataset.preorderText || '';

      /* 文言が空の場合は Liquid が出力した初期値を残す
         （通知ブロック側で必ずフォールバックしているため通常は発生しない） */
      if (text) input.value = text;
      input.disabled = false;
    } else {
      input.disabled = true;
    }
  }

  function syncAll() {
    document.querySelectorAll(NOTICE_SELECTOR).forEach(syncInput);
  }

  /* 通知ブロックの差し替えを検知する。
     クイックビューなど、後から DOM に挿入されるセクションにも対応するため
     document.body 全体を監視する（コールバックは closest 判定のみで軽量）。 */
  const observer = new MutationObserver(function (mutations) {
    const targets = new Set();

    for (const mutation of mutations) {
      const node = mutation.target;
      if (!node || typeof node.closest !== 'function') continue;

      const notice = node.closest(NOTICE_SELECTOR);
      if (notice) {
        targets.add(notice);
        continue;
      }

      /* セクションごと差し込まれたケース */
      if (typeof node.querySelectorAll === 'function') {
        node.querySelectorAll(NOTICE_SELECTOR).forEach((element) => targets.add(element));
      }
    }

    targets.forEach(syncInput);
  });

  function init() {
    syncAll();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
